import { PumpSizingFormData } from "../../types/types";
import { formatNumericValue } from "../helpers/helpers";
import { getGpmFormula } from "./gpm";
import {
	clearSumpLocationData,
	needsSumpRainfallLookup,
	resolveSumpRainfall,
} from "./resolveValues";
import { getTdhFormula } from "./tdh";

async function applyGpmCalculation(
	formData: PumpSizingFormData,
): Promise<PumpSizingFormData> {
	let nextFormData = formData;

	if (needsSumpRainfallLookup(nextFormData)) {
		nextFormData = await resolveSumpRainfall(
			clearSumpLocationData(nextFormData),
		);
	}

	const { applicationType, gpmData } = nextFormData;

	if (
		!applicationType ||
		applicationType === "email" ||
		gpmData.mode === "known"
	) {
		return nextFormData;
	}

	const formula = getGpmFormula(applicationType);
	if (!formula) {
		return nextFormData;
	}

	const result = formula(nextFormData);
	if (result === null || !Number.isFinite(result)) {
		return nextFormData;
	}

	return {
		...nextFormData,
		gpmData: {
			...nextFormData.gpmData,
			calculatedGpm: formatNumericValue(result),
		},
	};
}

function applyTdhCalculation(formData: PumpSizingFormData): PumpSizingFormData {
	const { applicationType, tdhData } = formData;

	if (!applicationType || tdhData.mode === "known") {
		return formData;
	}

	const formula = getTdhFormula(applicationType);
	if (!formula) {
		return formData;
	}

	const result = formula(formData);
	if (result === null || !Number.isFinite(result)) {
		return formData;
	}

	return {
		...formData,
		tdhData: {
			...tdhData,
			calculatedTdh: formatNumericValue(result),
		},
	};
}

export async function applyStepCalculations(
	formData: PumpSizingFormData,
	step: number,
): Promise<PumpSizingFormData> {
	switch (step) {
		case 2:
			return applyGpmCalculation(formData);
		case 3:
			return applyTdhCalculation(formData);
		default:
			return formData;
	}
}
